interface OperationTypeIdentity {
  resource: string;
  action: string;
}

/** Canonical `${resource}/${action}` key shared by cards and leaderboard columns. */
export const getOperationTypeKey = (operation: OperationTypeIdentity): string =>
  `${operation.resource}/${operation.action}`;
